import type { ScheduleStatus, DeviationStatus } from '../../../../features/arbeitszeit-report/filters'
import type { MultiSelectOption } from '../../../../shared/ui/controls/MultiSelectDropdown'
import type { ArbeitsorgOrganisationType, ArbeitszeitGesamtCategory } from '@myapp/contract'

export const SCHEDULE_STATUS_OPTIONS: ReadonlyArray<MultiSelectOption<ScheduleStatus>> = [
  { value: 'WITHOUT_FOLLOW_UP', label: 'Ohne Folgetermin' },
  { value: 'WITH_FOLLOW_UPS', label: 'Mit Folgeterminen' },
]

export const DEVIATION_STATUS_OPTIONS: ReadonlyArray<MultiSelectOption<DeviationStatus>> = [
  { value: 'ON_SCHEDULE', label: 'Planmäßig abgeschlossen' },
  { value: 'OVER_TARGET', label: 'Über Soll abgeschlossen' },
  { value: 'UNDER_TARGET', label: 'Unter Soll abgeschlossen' },
]

export const ORGANISATIONSTYP_LABELS: Record<ArbeitsorgOrganisationType, string> = {
  ERRANDS: 'Besorgungen',
  GENERAL_TASK: 'Allgemeine Aufgabe',
  SICK_LEAVE: 'Krank',
  VACATION: 'Urlaub',
  PERSONAL_LEAVE: 'Privat',
  TRAINING: 'Schulung',
}

export const GESAMT_CATEGORY_LABELS: Record<ArbeitszeitGesamtCategory, string> = {
  auftraege: 'Aufträge',
  allgemeinzeit: 'Allgemeinzeit',
  urlaub: 'Urlaub',
  krankheit: 'Krankheit',
  privat: 'Privat',
  gesamt: 'Gesamt',
}
